import * as Types from "../constants/Types";
import Tour, { TourTicket } from "../models/Tour";
import { PAGINATION } from "../constants/Define";
import { updateObjectInArray, getMomentDate } from "../utils/commonUtils";
import moment from "moment";
import { findIndex } from "lodash";
import Inventory from "../models/Inventory";

const initialState = {
  inventory: [],
  isFetching: false,
  inventoryDetail: new Inventory(),
  //   isFetchingDetail: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.INVENTORY_GET_LIST_ACTION:
    case Types.INVENTORY_DETAIL_ACTION:
      return { ...state, isFetching: true };
    case Types.INVENTORY_GET_LIST_SUCCESS:
      return { ...state, ...action };
    case Types.INVENTORY_DETAIL_SUCCESS:
      return { ...state, inventoryDetail: action.inventory };
    default:
      return state;
  }
};
